import { DataAccess } from "../../dataaccess/data.access";
import { ResponseMessage } from "../../dataaccess/data.access";

export interface CopySeriesDatabaseProcParams {
    sourceDb?: string;
    targetDb?: string;
    sourceWsInst?: string;
    targetWsInst?: string;
    sourceInstanceId?: string;
    targetInstanceId?: string;
}

export interface CopySeriesDatabaseJobDoc {
    jobId: string;
    status: string;
    message?: string;
    messageCode?: string;
    sourceInstance?: string;
    targetInstance?: string;
    startedAt?: string;
    completedAt?: string;
}

const BASE = "/service-portal/copy-series-database";

export class CopySeriesDatabaseService {
    public static listInstances(): Promise<CopySeriesDatabaseProcParams[]> {
        return DataAccess.get(
            DataAccess.injectCaller(`${BASE}/instances.json`, "CopySeriesDatabaseService.listInstances"),
        );
    }

    public static async startCopy(targetInstanceId: string): Promise<CopySeriesDatabaseJobDoc> {
        const response = await DataAccess.post<ResponseMessage<CopySeriesDatabaseJobDoc>>(
            DataAccess.injectCaller(`${BASE}.json`, "CopySeriesDatabaseService.startCopy"),
            { targetInstanceId },
        );
        return response.upsertData as CopySeriesDatabaseJobDoc;
    }

    public static async getJobStatus(jobId: string): Promise<CopySeriesDatabaseJobDoc> {
        const response = await DataAccess.get<ResponseMessage<CopySeriesDatabaseJobDoc>>(
            DataAccess.injectCaller(`${BASE}/jobs/${jobId}.json`, "CopySeriesDatabaseService.getJobStatus"),
        );
        return response.upsertData as CopySeriesDatabaseJobDoc;
    }

    public static formatError(error: { status?: number; data?: ResponseMessage }): string {
        if (error?.status === 401) {
            return "Unauthorized.";
        }
        if (error?.status === 409) {
            return error.data?.message || "A database copy is already in progress. Please wait and try again.";
        }
        if (error?.status === 400) {
            return error.data?.message || "Invalid request.";
        }
        return error?.data?.message || "Unable to start database copy.";
    }
}
